export const BIRTHDAY_EVENT_TYPE = 'birthday';
export const BABY_SHOWER_EVENT_TYPE = 'baby-shower';
export const POOL_PARTY_EVENT_TYPE = 'pool-party';
export const EVJF_EVENT_TYPE = 'EVJF';
export const TEAM_BUILDING_EVENT_TYPE = 'team-building';



// WEBPACK FOOTER //
// ./src/util/eventCategory.js